import { render, staticRenderFns } from "./AddMaterial.vue?vue&type=template&id=790cc787&scoped=true"
import script from "./AddMaterial.vue?vue&type=script&lang=js"
export * from "./AddMaterial.vue?vue&type=script&lang=js"
import style0 from "./AddMaterial.vue?vue&type=style&index=0&id=790cc787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790cc787",
  null
  
)

export default component.exports